import React, { useContext } from 'react';
import {  object,string } from 'prop-types';
import { AppContext } from '../AppContext';

import MapIcon from './MapIcon';

function Locations({ searchKey,allPlaces, classForMobile }) {
  const { onClick, theme } = useContext(AppContext);
  let setMapper = {}
  let cityState ={name:"",place:{}}
  const locations = allPlaces.filter(place => {
    if(!cityState.name){
      if(place.city
          .toLowerCase()
          .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase())){
        cityState ={name :place.city, place:place}
      }else if( place.state_name
          .toLowerCase()
          .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase())){
        cityState ={name :place.state_name, place:place}
      }
    }
       return place.city
        .toLowerCase()
        .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase())|| place.state_name
           .toLowerCase()
           .includes(searchKey.substring(0, searchKey.trim().length).toLowerCase());

  }).reduce((unique, item) => {
    if(item && item.value && !setMapper[item.value]) {
      let key = `${item.city}${item.state_name}`
      if(key && !setMapper[key]){
        unique.push(item);
        setMapper[key] = true;
      }
      return unique;
    }
    return unique;
  }, [{city:cityState.name,data:{location:`${cityState.place.city}${cityState.place.state_name ? "," : ""} ${cityState.place.state_name ? cityState.place.state_name : ""}${cityState.place.country ? "," : ""} ${cityState.place.country ? cityState.place.country : ""}`}}]).map((item, index) => {
    if (item.city) {
      //console.log(item);
      return (

          <button
              key={index}
              onClick={onClick}
              className={classForMobile === true ? "autocomplete-suggestion suggestion" : "cell small-12 medium-6 large-4 find-a-hotel-suggestion suggestion"}
              style={{textAlign: 'left'}}
              data-value={`${item.city}${item.state_name ? "," : ""} ${item.state_name ? item.state_name : ""}`}
          >
            <MapIcon alt={theme.alt} src={theme.src}/>
            <span>{`${item.city}${item.state_name ? "," : ""} ${item.state_name ? item.state_name : ""}`}</span>
           </button>
      );
    }
  });
  return locations;
}

Locations.propTypes = {
  //filtered: array.isRequired,
  theme: object,
  searchKey:string,
  allPlaces:object
};

export default Locations;
